UIController.define('UIThirdPartyLoginController', {

  didClick: function didClick(container, target) {
    if (DOM.hasClass(target, 'moreOptionsLink')) {
      DOM.toggleClass(container, 'isExpanded');
    }

    return EventDelegater.FORWARD;
  }
});
